// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-mask[data-v-5b8ae8f6] {\n    padding-left: 10px;\n    min-height: 40px !important;\n    max-height: 40px !important;\n    border-radius: 4px;\n    box-sizing: border-box;\n    width: 100%;\n}\n.input-mask--border[data-v-5b8ae8f6] {\n    border: solid 2px transparent;\n}\n.input-mask--border[data-v-5b8ae8f6]:focus {\n    border: solid 2px var(--color-dark-pastel-green);\n}\n", ""]);
// Exports
module.exports = exports;
